import { didiIntroTour } from './tours/didiIntro';
import type { TourDefinition } from './types';

/**
 * Every tour in the app, highest priority first — TourHost runs the first one
 * the current user is eligible for and hasn't dismissed.
 *
 * To add a tour:
 *  1. Drop a definition in ./tours/.
 *  2. Add it here.
 *  3. Add its key to UserToursController::TOUR_KEYS (the server allowlist).
 *  4. Give each step a stable [data-tour="..."] anchor in the markup.
 *
 * To re-show a tour after changing its copy, bump its `version`.
 */
export const TOURS: TourDefinition[] = [didiIntroTour];
